export const UPDATE_SUBMISSION_PROGRESS_STAGE = Symbol('UPDATE_SUBMISSION_PROGRESS_STAGE');

export function updateSubmissionProgressState(stage = undefined) {
    return {
        type:       UPDATE_SUBMISSION_PROGRESS_STAGE,
        payload:    stage
    }
}